import React from 'react';
import './TransactionDetails.css';

function TransactionDetails({ transaction }) {
  if (!transaction) return null;

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Pending';
    return new Date(timestamp * 1000).toLocaleString('de-DE');
  };

  const formatBTC = (value) => {
    return value ? value.toFixed(8) : '0.00000000';
  };

  return (
    <div className="transaction-details">
      <h2>📋 Transaktions-Details</h2>

      <div className="detail-section">
        <h3>Allgemein</h3>
        <div className="detail-row">
          <span className="label">TX ID:</span>
          <span className="value tx-id">{transaction.txid}</span>
        </div>
        <div className="detail-row">
          <span className="label">Block Höhe:</span>
          <span className="value">{transaction.block_height || 'Pending'}</span>
        </div>
        <div className="detail-row">
          <span className="label">Zeitstempel:</span>
          <span className="value">{formatDate(transaction.timestamp)}</span>
        </div>
      </div>

      <div className="detail-section">
        <h3>💰 Beträge</h3>
        <div className="detail-row">
          <span className="label">Gesamt Input:</span>
          <span className="value btc-amount">{formatBTC(transaction.total_input)} BTC</span>
        </div>
        <div className="detail-row">
          <span className="label">Gesamt Output:</span>
          <span className="value btc-amount">{formatBTC(transaction.total_output)} BTC</span>
        </div>
        <div className="detail-row">
          <span className="label">Gebühr:</span>
          <span className="value fee-amount">{formatBTC(transaction.fee)} BTC</span>
        </div>
      </div>

      <div className="detail-section">
        <h3>📥 Inputs ({transaction.inputs.length})</h3>
        <div className="io-list">
          {transaction.inputs.map((input, index) => (
            <div key={index} className="io-item">
              <div className="io-address">
                {input.address || 'Coinbase (Mining Reward)'}
              </div>
              {input.value && (
                <div className="io-value">{formatBTC(input.value)} BTC</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="detail-section">
        <h3>📤 Outputs ({transaction.outputs.length})</h3>
        <div className="io-list">
          {transaction.outputs.map((output, index) => (
            <div key={index} className="io-item">
              <div className="io-address">
                {output.address || 'Unknown'}
              </div>
              <div className="io-value">{formatBTC(output.value)} BTC</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TransactionDetails;
